import React from 'react';

import IconMessage from '../IconMessage/IconMessage';
import IconPhone from '../IconPhone/IconPhone';

import css from './ListingCard.module.scss';

const TopListingsByLeadsBlock = (props) => {
  const {
    phoneCallsCount,
    messagesCount,
  } = props;

  return (
    <>
      <div className={css.counters}>
        <IconPhone />
        <div>Clicks on the number: <span>{phoneCallsCount}</span></div>
      </div>
      <div className={css.counters}>
        <IconMessage />
        <div>Messages: <span>{messagesCount}</span></div>
      </div>
    </>
  );
};

export default TopListingsByLeadsBlock;
